import { create } from 'zustand';
import { ConnectionStatus } from '../lib/socket/SocketManagerSimple';

interface ConnectionState {
  status: ConnectionStatus;
  reconnectAttempt: number;
  maxReconnectAttempts: number;
  lastDisconnectReason: string | null;
  
  setStatus: (status: ConnectionStatus) => void;
  setReconnectAttempt: (attempt: number, max: number) => void;
  setDisconnectReason: (reason: string | null) => void;
  reset: () => void;
}

export const useConnectionStore = create<ConnectionState>((set) => ({
  status: 'disconnected',
  reconnectAttempt: 0,
  maxReconnectAttempts: 5,
  lastDisconnectReason: null,

  setStatus: (status) => set({ status }),
  
  setReconnectAttempt: (attempt, max) => set({ 
    reconnectAttempt: attempt, 
    maxReconnectAttempts: max 
  }),
  
  setDisconnectReason: (reason) => set({ lastDisconnectReason: reason }),
  
  reset: () => set({
    status: 'disconnected',
    reconnectAttempt: 0,
    lastDisconnectReason: null,
  }),
}));
